export default "/search_bg.063198c3-90a8d6.png";